import { SHOW_MODAL_MORE_ACTIONS_GENERAL }  from "../../core/constants";

//action creator
export function showModalMoreActions (data)
{
    return {
        type: SHOW_MODAL_MORE_ACTIONS_GENERAL,
        payload: data,
    }
}